import {WBCommonException} from './exception';

export class SystemException extends WBCommonException {
    public name = 'SystemException';

    constructor(public message: string, public error: any) {
        super(message);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/exception/entity/system.exception.ts